import { findEvent } from '../../../packages/src/api/index.js';
import { defaultValue, setHtml, makeText } from './lib.js';

init();

const defaultText = defaultValue(`
    <h4>How do I get my pictures and videos?</h4>
    <p>We use state of the part face recognition technology that will find photos and videos we
	   made of you and your party throughout your experience. To take advantage of this feature,
	   you must register portrait photos (selfies) of each member of your party.</p>
    <h4>What does a Storibox Pass include?</h4>
        With a Storibox Pass, you may<br>
        <ul>
           <li>Download and save  high-resolution images and videos.</li>
           <li>Instantly share the exciting memories with your friends and family.</li>
           <li>Make personalized photos with available merchandises and have them
               printed right away.</li>
           <li>Access to your content for up to 60 days post your visit – providing you
               with the freedom to purchase more memorabilia at a later date.</li>
        </ul>
     <h4>I have purchased a Storibox Pass. When can I begin downloading my photos?</h4>
     <p>With a Storibox Pass, you may begin downloading as soon as photos are
        available in your account. You may choose to download them immediately or
        after your trip, because the photos will be available for up to 60 days from the
        day of your visit.
      </p>
      <h4>I have not decided to get a Storibox Pass. Can I still view my images?</h4>
      <p>If you did not purchase a digital pass, you can still preview your images, but they will be watermarked.</p>
      <h4>Where can I pick up the merchandises?</h4>
      <p>Ask one of our staff on site to help you locating the merchandise sales locations.</p>
      <h4>Do I have an option to ship purchased merchandise to my home?</h4>
      <p>Yes. Simply provide the address and our couriers will ensure
         your shopping cart is delivered to your doorstop. This service is available for
         up to 60 days post your visit.</p>
  `);

async function init() {
  const response = await findEvent({ eventName: localStorage.getItem('eventName') });
  const { opts } = response.result;
  const content = makeText('.html-content');
  setHtml(defaultText(opts.FAQText), content);
}
